import React from 'react';
import { useTheme } from '../context/ThemeContext';

export function KeyboardControls() {
  const { isDarkMode } = useTheme();
  
  return (
    <div className={`hidden md:block text-center ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
      <p className="text-sm">
        Press <kbd className={`px-2 py-1 rounded-md border ${
          isDarkMode 
            ? 'bg-gray-800 border-gray-700 text-gray-300' 
            : 'bg-gray-100 border-gray-300'
        }`}>space</kbd> to generate a new gradient
      </p>
    </div>
  );
}